import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import lookupService from "services/lookupService";
import find from "lodash/find";
import sortBy from "lodash/sortBy";

export const getCountryList = createAsyncThunk(
	"vino/lookups/getCountryList",
	async () => {
		const countryList = await lookupService.fetchCountryList();
		return countryList;
	}
);

export const getStateList = (countyId) => (dispatch, getState) => {
	const countryList = getState().vino.lookups.countryList;
	const country = find(countryList, { id: countyId });
	const stateList = sortBy(country.states.nodes, "name");
	dispatch(setStateList({ countyId, stateList }));
};

const lookupsSlice = createSlice({
	name: "vino/lookups",
	initialState: {
		states: {},
		countryList: [],
	},
	reducers: {
		setStateList: (state, action) => {
			const { countyId, stateList } = action.payload;
			state.states[countyId] = stateList;
		},
	},

	extraReducers: {
		[getCountryList.fulfilled]: (state, action) => {
			state.countryList = action.payload;
		},
		[getStateList.fulfilled]: (state, action) => {
			const { countyId, stateList } = action.payload;
			state.states[countyId] = stateList;
		},
	},
});

export const { setStateList } = lookupsSlice.actions;
export default lookupsSlice.reducer;
